import "./Congratulations.scss";

import { Button, Flex, Text } from "@fluentui/react-northstar";
import { TeamsSubscriptionPlans } from "@teams/types";
import moment from "moment";
import React from "react";

import CoreConfirmationAnimation from "../../assets/confirmation-image-ok-mark.svg";
import { getPageContext } from "../../utils/teamsHelpers";

type Props = {
  plan: TeamsSubscriptionPlans;
  trialEnd?: Date;
  onClose?: () => void;
  closeButtonText?: string;
  licenseRequest?: boolean;
};

export const Congratulations: React.FC<Props> = ({
  trialEnd,
  onClose,
  closeButtonText,
  licenseRequest,
}) => {
  const pageContext = getPageContext();

  return (
    <div>
      <Text
        content={
          licenseRequest
            ? "Request received!"
            : `Congratulations! Your ${
                pageContext === "/agile" ? "AgilePolly" : "Polly"
              } subscription has been activated.`
        }
        size="larger"
        weight="bold"
        align="center"
        as="div"
      />
      {licenseRequest && (
        <Text
          content="We've also granted you a free trial for the next 14 days."
          as="div"
          align="center"
        />
      )}

      <img
        src={CoreConfirmationAnimation}
        className="congratulations__success_img"
        alt="Success"
        width="100%"
        height={150}
      />

      {trialEnd && !licenseRequest && (
        <Text
          size="medium"
          content={`You will be able to trial Polly for free until ${moment(trialEnd).format(
            "LL"
          )} at which point your credit card will be charged`}
          align="center"
        />
      )}

      {onClose && (
        <div>
          <Text
            size="medium"
            content="Navigate back to teams by clicking the button below or refresh your view in the desktop app to see your new plan applied."
            align="center"
          />
          <Flex hAlign="end" className="congratulations__back-teams">
            <Button
              className="congratulations__done_btn"
              data-tname="subscription-confirmation-message-close"
              content={closeButtonText ?? "Done"}
              primary
              onClick={onClose}
            />
          </Flex>
        </div>
      )}
    </div>
  );
};
